module.exports = __webpack_public_path__ + "static/media/Yellow arrow rotate.28b5c380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wordMark2/Yellow arrow rotate.png
// module id = 864
// module chunks = 0